import { useEffect, useState } from 'react';
import { Engine } from 'json-rules-engine';
import _ from 'lodash'; // to use the lodash path resolver, for example
import { getProfileFromLocalStorage } from '../utils/helperFunctions';

export const ShouldRenderComponent = (props) => {
  const { visibilityCondition, children, currentFragment } = props;
  const [render, setRender] = useState(!visibilityCondition);
  useEffect(() => {
    const figureOut = async () => {
      setRender(await shouldItRender(visibilityCondition, currentFragment));
    };

    figureOut();
  }, [visibilityCondition, currentFragment, setRender]);
  if (render) {
    return children;
  }
  return null;
};

function pathResolver(object, path) {
  if (path == null || path === '') {
    return object;
  }
  let normalized = path;
  if (normalized.startsWith('$.')) {
    normalized = normalized.slice(2);
  } else if (normalized.startsWith('.')) {
    normalized = normalized.slice(1);
  }
  const resolved = _.get(object, normalized);
  if (
    resolved &&
    typeof resolved === 'object' &&
    !Array.isArray(resolved) &&
    'value' in resolved &&
    !resolved._id
  ) {
    return resolved.value;
  }
  return resolved;
}

const shouldItRender = async (visibilityCondition, currentFragment) => {
  try {
    const profileHash = getProfileFromLocalStorage();
    let result = true;
    const conditionsWithEvent = {
      conditions: visibilityCondition,
      event: {
        type: 'no-event',
      },
    };
    let engine = new Engine([], { pathResolver: pathResolver, allowUndefinedFacts: true });
    if (visibilityCondition) {
      engine.addRule(conditionsWithEvent || undefined);
      let facts = {
        uiVisibilityHash: profileHash?.uiVisibilityHash,
        roles: (profileHash?.roles || []).map((_role) => _role.label),
        currentFragment,
      };
      const output = await engine.run(facts);
      // Assuming there can be only one rule
      if (output.results.length) {
        result = true;
      } else {
        result = false;
      }
    }
    return result;
  } catch (e) {
    // Fail closed when a visibility rule is present so restricted UIs stay hidden
    console.warn('Visibility rule evaluation failed', e);
    return !visibilityCondition;
  }
};

const getObjectValue = (obj, str) => {
  const keys = str.split('.');
  let value = obj;

  for (let key of keys) {
    if (value && value.hasOwnProperty(key)) {
      value = value[key];
    } else {
      value = undefined;
      break;
    }
  }

  return value;
};
